import Types, { getValueType } from '../../types';

import StringEditor from './string';
import NumberEditor from './number';
import BooleanEditor from './boolean';
import ObjectEditor from './object';
import ArrayEditor from './array';
import JSONValueEditor from './json';

const EditorsForType = {
	[Types.array]:ArrayEditor,
	[Types.object]:ObjectEditor,
	[Types.string]:StringEditor,
	[Types.number]:NumberEditor,
	[Types.boolean]:BooleanEditor,
}

const EditorsForSpecialType = {
	[Types.json]: JSONValueEditor
};

export function editorForType(type) {
	return EditorsForType[type];
}

export function editorForSpecialType(type) {
	return EditorsForSpecialType[type];
}

export default function editorForValue(value) {
	return editorForType(getValueType(value));
}
